import classNames from "classnames";
import { get } from "lodash";
import { MdAdd, MdRemove } from "react-icons/md";

const getLevelLabel = (value, labels, translate, needsLevels) => {
  if (labels[String(value)]) {
    return labels[String(value)];
  }
  const defaultLabels = {
    1: translate?.LEVELS?.MINIMUM,
    2: translate?.LEVELS?.PARTIEL,
    3: translate?.LEVELS?.RENFORCE,
    4: translate?.LEVELS?.CONFORT,
    5: translate?.LEVELS?.SUPERIEUR,
  };
  return (
    defaultLabels[value] ||
    `${translate?.LEVELS?.LEVEL_LABEL || "Niveau"} ${value}`
  );
};

const getLevelDescription = (
  value,
  categoryId,
  categoryValue,
  categoriesConfig,
  translate,
) => {
  const configText = get(categoriesConfig, `${categoryId}.${value}.text`, null);
  if (configText) {
    return configText;
  }

  const categoryMap = {
    ROUTINE_CARE: "ROUTINE_CARE",
    hospitalization: "HOSPITALIZATION",
    optical: "OPTICAL",
    dental: "DENTAL",
    preventionAndWellBeing: "PREVENTION_AND_WELL_BEING",
  };
  const categoryKey = categoryMap[categoryValue] || "ROUTINE_CARE";
  const levelMap = {
    1: "MINIMUM",
    2: "CONFORT",
    3: "CONFORT_PLUS",
    4: "OPTIMAL",
    5: "MAXIMUM",
  };
  const levelKey = levelMap[value] || "MINIMUM";
  return (
    get(translate, `LEVELS.${categoryKey}.${levelKey}`) ||
    get(translate, `LEVELS.ROUTINE_CARE.${levelKey}`) ||
    "Consultation sans dépassement d'honoraires"
  );
};

const NeedSlider = ({
  category,
  value,
  onChange,
  translate,
  needsLevels = 5,
  labels = {},
  categoriesConfig = {},
}) => {
  const currentLevelLabel = getLevelLabel(
    value,
    labels,
    translate,
    needsLevels,
  );
  const description = getLevelDescription(
    value,
    category.id,
    category.value,
    categoriesConfig,
    translate,
  );

  const handleDecrease = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < needsLevels) {
      onChange(value + 1);
    }
  };

  const handleDotClick = (dotValue) => {
    onChange(dotValue);
  };

  const progressPercent =
    needsLevels > 1 ? ((value - 1) / (needsLevels - 1)) * 100 : 0;

  return (
    <div className="acoris-need-slider">
      <div className="acoris-need-slider__header">
        <div className="acoris-need-slider__info">
          <img
            src={category.icon}
            alt={category.label}
            className="acoris-need-slider__icon"
          />
          <span className="acoris-need-slider__title">{category.label}</span>
        </div>
        <div className="acoris-need-slider__level">
          <span className="acoris-need-slider__level-label">
            {currentLevelLabel}
          </span>
          <span
            className="acoris-need-slider__level-divider"
            aria-hidden="true"
          />
          <span
            className="acoris-need-slider__level-description"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
      <div className="acoris-need-slider__controls">
        <button
          className="acoris-need-slider__btn acoris-need-slider__btn--minus"
          onClick={handleDecrease}
          disabled={value <= 1}
          type="button"
          aria-label="Diminuer"
        >
          <MdRemove />
        </button>
        <div className="acoris-need-slider__track">
          <div className="acoris-need-slider__track-line" />
          <div className="acoris-need-slider__track-inner">
            <div
              className="acoris-need-slider__track-filled"
              style={{ width: `${progressPercent}%` }}
            />
            {Array.from({ length: needsLevels }, (_, i) => i + 1).map(
              (dotValue) => (
                <button
                  key={dotValue}
                  type="button"
                  className={classNames("acoris-need-slider__dot", {
                    "acoris-need-slider__dot--active": dotValue === value,
                    "acoris-need-slider__dot--filled": dotValue <= value,
                  })}
                  style={{
                    left: `${((dotValue - 1) / (needsLevels - 1)) * 100}%`,
                  }}
                  onClick={() => handleDotClick(dotValue)}
                  aria-label={`Niveau ${dotValue}`}
                />
              ),
            )}
            <div
              className="acoris-need-slider__handle"
              style={{ left: `${progressPercent}%` }}
            />
          </div>
        </div>
        <button
          className="acoris-need-slider__btn acoris-need-slider__btn--plus"
          onClick={handleIncrease}
          disabled={value >= needsLevels}
          type="button"
          aria-label="Augmenter"
        >
          <MdAdd />
        </button>
      </div>
    </div>
  );
};

export default NeedSlider;
